module.exports = __webpack_public_path__ + "3e1c44572e0d078b3398a31f8f1afc61.jpg";